import { useCallback, useState } from "react";
import { Flex, QueryLoader, AgGrid } from "@jsq/ds/core";
import Titlebar from "../components/Titlebar";
import { useAgGridUtils } from "../utils/gridUtils";
import { WorkspaceTable } from "./components/WorkspaceTable";
import { useFetchWorkspaces } from "./hooks";
import * as styles from "./styles_vanilla.css";
import { WorkspaceData } from "./types";
import { WorkspaceDetailsDrawer } from "./WorkspaceDetailsDrawer";

const WorkspacesPage: React.FC = () => {
  const [sortByName, setSortByName] = useState(true);
  const { rowData, useGetWorkspacesQueryResult } = useFetchWorkspaces({
    sortByName,
  });
  const [isWorkspaceDetailsOpen, setIsWorkspaceDetailsOpen] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<WorkspaceData | undefined>();

  const { gridApi, onGridReady, resetFilters, isFilterPresent, onFilterChanged } =
    useAgGridUtils<WorkspaceData>();

  const onRowClicked = useCallback((event: AgGrid.RowClickedEvent<WorkspaceData>) => {
    setSelectedWorkspace(event.data);
    setIsWorkspaceDetailsOpen(true);
  }, []);

  return (
    <Flex
      alignItems="center"
      justifyContent="center"
      flexGrow={1}
      data-testid="workspaces-page"
    >
      <QueryLoader result={useGetWorkspacesQueryResult}>
        <Flex flexDirection="column" flexGrow={1} className={styles.contentWrapper}>
          <Flex justifyContent="space-between" alignItems="center"></Flex>
          <Titlebar
            marginBottom="md"
            title="Workspaces"
            variant="h2"
            actionButtons={[
              {
                show: isFilterPresent,
                buttonProps: {
                  variant: "neutral",
                  icon: "times",
                  key: "clear_filters",
                  onClick: resetFilters,
                  children: "Clear filters",
                },
              },
            ]}
          />
          <div className={styles.tableWrapper}>
            <WorkspaceTable
              gridApi={gridApi}
              onGridReady={onGridReady}
              rowData={rowData}
              onSortChanged={() => setSortByName((prev) => !prev)}
              onRowClicked={onRowClicked}
              onFilterChanged={onFilterChanged}
            />
          </div>
        </Flex>
        <WorkspaceDetailsDrawer
          isOpen={isWorkspaceDetailsOpen}
          onClose={() => setIsWorkspaceDetailsOpen(false)}
          workspaceData={selectedWorkspace}
        />
      </QueryLoader>
    </Flex>
  );
};

export default WorkspacesPage;
